module.exports = __webpack_public_path__ + "static/img/010.6e077fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/samples/010.jpg
// module id = 892
// module chunks = 0